import { render } from "./ResultField.vue?vue&type=template&id=9e4ad2f0"
import script from "./ResultField.vue?vue&type=script&lang=js"
export * from "./ResultField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\game\\front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__